import styled from "styled-components";

export const ShowAnswer = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--brand-primary);

  &:hover {
    color: var(--color-highlight-dark);
  }
`;

export const AnswerWrapper = styled.div<{ expanded: boolean }>`
  max-height: ${(props) => (props.expanded ? 'none' : '10rem')};
  overflow: hidden;
  line-height: 1.5rem;
  position: relative;
  transition: max-height 0.3s ease;
  margin-bottom: 2rem;
  
  ol + ul {
    margin-left: 15px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${(props) => (props.expanded ? '0' : '1.5rem')};
  }
`;
